import React from "react";

const PlayButton = ({ border, MainStartRecording, click, src, btnText, altName }) => {
    return (
        <div>
            <button
                style={{
                    padding: "14px 30px",
                    borderRadius: "8px",
                    background: border ? "transparent" : "#F2423C",
                    color: border ? "#F2423C" : "#ffffff",
                    border: border ? "1px solid #F2423C" : "none",
                    cursor: "pointer",
                    fontWeight: "700",
                    fontFamily: "Metropolis",
                    // height: "53px",
                    // width: MainStartRecording ? "218px" : '146px',
                   
                


                }}
                onClick={click}
            >
                <img src={src} alt={altName} style={{ marginRight: "10px",  }}  />
                {btnText}
            </button>
        </div>
    );
};

export default PlayButton;
